export type User = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  firstName: string;
  lastName: string;
  school: string | null;
};
